export default __webpack_public_path__ + "static/media/carot-right.23479187.svg";